import z from "zod";
import Fetcher from "../Fetcher";

/**
 * THE TYPES BELOW SHOULD BE KEPT IN SYNC WITH THE BACKEND
 * src/Threats/types.ts
 */

// These are the database enum types
export type ThreatType = "FILE_SCAN" | "PROMPT_ATTACK" | "SENSITIVE_DATA";
type ThreatEntityType = "FILE_UPLOAD" | "USER_TEXT";

export const ThreatProducts = {
    RFQ: "RFQ",
    QUOTE_COMPARE: "QUOTE_COMPARE",
} as const;

const ThreatProductTypeSchema = z.enum(ThreatProducts);

export type ThreatProductType = z.infer<typeof ThreatProductTypeSchema>;

export type ThreatListItem = {
    id: number;
    createdAt: Date;
    threatType: ThreatType;
    entityType: ThreatEntityType;
    userId: number | null;
    affectedProducts: ThreatProductType[];
};

export type ThreatItemDetail = {
    id: number;
    createdAt: Date;
    threatType: ThreatType;
    entityType: ThreatEntityType;
    userId: number | null;
    userDisplayName: string | null;
    explanation: string | null;
    productDetails: ThreatProductDetail[];
};

export type ThreatProductDetail =
    | {
          productType: typeof ThreatProducts.RFQ;
          fileId: number;
          rfqPublicId: string;
          mailboxId?: number;
          communicationId?: number;
      }
/**
 *
 */

export type ThreatListResponse = {
    threats: ThreatListItem[];
    nextCursor: number | null;
};

const f = Fetcher.default();

export default {
    getThreats: async (params?: { cursor?: number; limit?: number; threatType?: ThreatType }): Promise<ThreatListResponse> => {
        const searchParams = new URLSearchParams();
        if (params?.cursor) searchParams.set("cursor", params.cursor.toString());
        if (params?.limit) searchParams.set("limit", params.limit.toString());
        if (params?.threatType) searchParams.set("threatType", params.threatType);

        const queryString = searchParams.toString();
        return await f.get<ThreatListResponse>(`/security/threats${queryString ? `?${queryString}` : ""}`);
    },
    getThreatDetail: async (id: number) => {
        return await f.get<ThreatItemDetail>(`/security/threats/${id}`);
    },
};
